import styled from '@emotion/styled'
import SVGLoader from '@src/components/svg/SVGLoader'

type PropsType = {
	selectPage: (i: number) => void
	page: number
}
const NextBtn = ({ selectPage, page }: PropsType) => {
	return (
		<MovePageIconWrapper
			onClick={() => {
				if (selectPage) selectPage(page)
			}}
		>
			<SVGLoader name="leftArrowIcon" />
		</MovePageIconWrapper>
	)
}

export const MovePageIconWrapper = styled.button`
	transform: rotate(180deg);
	display: inline-block;
	width: 8px;
	height: 14px;
	background: none;
	border: none;
	padding: 0;
`
export default NextBtn
